import {Card, type CardProps} from 'platform/components';
import {HStack, Show, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {type RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {StockTakeReportMetric} from '../types/StockTakeReportMetric';

export type MonthlyStockTakeMetric = StockTakeReportMetric;

interface MonthlyStockTakeSectionProps extends RequiredTestIdProps {
  title: string;
  metrics: MonthlyStockTakeMetric[];
  colorStripe?: CardProps['colorStripe'];
}

export function MonthlyStockTakeSection(props: MonthlyStockTakeSectionProps) {
  return (
    <section role="group" aria-label={props.title}>
      <Card
        title={props.title}
        isFullHeight
        colorStripe={props.colorStripe ?? 'blue'}
        data-testid={props['data-testid']}
      >
        <VStack spacing={2}>
          {props.metrics.map((metric) => (
            <section
              key={metric.id}
              role="group"
              aria-label={metric.label}
              data-testid={suffixTestId(metric.id, props)}
            >
              <VStack spacing={0}>
                <HStack justify="space-between" spacing={2} align="baseline">
                  <Text size="xSmall" color="secondary">
                    {metric.label}
                  </Text>
                  <Text size="small" alternative align="right">
                    {metric.value}
                  </Text>
                </HStack>
                <Show when={isNotNil(metric.note)}>
                  <Text size="xxSmall" color="secondary">
                    {metric.note}
                  </Text>
                </Show>
              </VStack>
            </section>
          ))}
        </VStack>
      </Card>
    </section>
  );
}
